import { useState, useEffect } from 'react';
import { fmtAmount, fmtDate } from '../lib/helpers';
import { api } from '../lib/api';

export function CashbookPage({ parties, onPartyClick }) {
  const [txns, setTxns]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter]   = useState('all');
  const [search, setSearch]   = useState('');

  useEffect(() => {
    api.getTransactions().then(t => { setTxns(t); setLoading(false); });
  }, []);

  const partyName = (pid) => parties.find(p => p.id === pid)?.name || 'Unknown';

  const filtered = txns.filter(t => {
    const matchType   = filter === 'all' ? true : t.type === filter;
    const name        = partyName(t.party_id).toLowerCase();
    const matchSearch = name.includes(search.toLowerCase()) ||
                        (t.note || '').toLowerCase().includes(search.toLowerCase());
    return matchType && matchSearch;
  });

  const totalCredit = filtered.filter(t => t.type === 'credit').reduce((s, t) => s + t.amount, 0);
  const totalDebit  = filtered.filter(t => t.type === 'debit').reduce((s, t) => s + t.amount, 0);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this entry?')) return;
    await api.deleteTransaction(id);
    setTxns(prev => prev.filter(t => t.id !== id));
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Totals */}
      <div className="report-total-bar">
        <div className="report-total-item">
          <div className="report-total-label">Total Credit</div>
          <div className="report-total-amount" style={{ color: 'var(--green-dark)' }}>{fmtAmount(totalCredit)}</div>
        </div>
        <div className="report-total-item">
          <div className="report-total-label">Total Debit</div>
          <div className="report-total-amount" style={{ color: 'var(--red-dark)' }}>{fmtAmount(totalDebit)}</div>
        </div>
        <div className="report-total-item">
          <div className="report-total-label">Entries</div>
          <div className="report-total-amount">{filtered.length}</div>
        </div>
      </div>

      {/* Search */}
      <div className="search-bar">
        <span>🔍</span>
        <input className="search-input" placeholder="Search by party name or note..."
          value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      {/* Filter chips */}
      <div className="chip-bar">
        {[
          { id: 'all',    label: 'All Entries' },
          { id: 'credit', label: '📥 Credit' },
          { id: 'debit',  label: '📤 Debit' },
        ].map(c => (
          <button key={c.id} className={`chip${filter === c.id ? ' active' : ''}`}
            onClick={() => setFilter(c.id)}>{c.label}</button>
        ))}
      </div>

      {/* List */}
      <div className="content">
        <div style={{ padding: '12px 16px' }}>
          {loading ? (
            <div className="empty">
              <div className="loading-spin" style={{ margin: '0 auto 8px' }} />Loading…
            </div>
          ) : filtered.length === 0 ? (
            <div className="empty">
              <div className="empty-icon">📒</div>
              No entries found
            </div>
          ) : (
            <div className="txn-list">
              {filtered.map(t => (
                <div key={t.id} className="txn-row"
                  style={{ cursor: 'pointer' }}
                  onClick={() => { const p = parties.find(x => x.id === t.party_id); if (p) onPartyClick(p); }}>
                  <div className={`txn-dot ${t.type}`}>
                    {t.type === 'credit' ? '📥' : '📤'}
                  </div>
                  <div className="txn-info">
                    <div className="txn-note">{t.note || (t.type === 'credit' ? 'Credit entry' : 'Debit entry')}</div>
                    <div className="txn-party">👤 {partyName(t.party_id)}</div>
                    <div className="txn-date">{fmtDate(t.date)}</div>
                  </div>
                  <div className="txn-right">
                    <div className={`txn-amount ${t.type}`}>{fmtAmount(t.amount)}</div>
                    <div className={`txn-label ${t.type}`}>{t.type === 'credit' ? 'Credit' : 'Debit'}</div>
                  </div>
                  <button className="delete-btn" onClick={e => { e.stopPropagation(); handleDelete(t.id); }}>🗑</button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
